<template>
  <div class="custom-top-info">
    <h1 style="width: 45%">{{ title }}</h1>
    <data-block class="no-margin-bottom" :dataToShow="{key:'Total', value:cardLoaded}"></data-block>
    <data-block v-if="val1" class="no-margin-bottom" :dataToShow="val1"></data-block>
    <data-block v-else class="no-margin-bottom"></data-block>
    <data-block v-if="val2" class="no-margin-bottom" :dataToShow="val2"></data-block>
    <data-block v-else class="no-margin-bottom"></data-block>
    <div class="btn-topbar">
      <el-tooltip class="item" effect="dark" :content="$t('create')" placement="top">
        <el-button v-if="isSuperAdmin" type="success" icon="el-icon-plus" @click="create" circle></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('load')" placement="top" v-if="!allLoaded">
        <el-button type="primary" icon="el-icon-refresh-right" @click="loadMore" :disabled="allLoaded" circle></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('refresh')" placement="top">
        <el-button type="primary" icon="el-icon-refresh" @click="refresh" circle></el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import DataBlock from './DataBlock.vue'

  export default {
    components: {
      DataBlock
    },
    props: {
      cardLoaded: {
        type: Number,
        default: 0
      },
      val1: {
        type: Object
      },
      val2: {
        type: Object
      },
      title: {
        type: String
      },
      isLoaded: {
        type:String,
        required: true
      }
    },
    data() {
      return {
        msg: 'Hi there!',
        isSuperAdmin: false
      }
    },
    created() {
      this.isSuperAdmin = this.$store.getters.isSuperAdmin;
    },
    computed: {
      allLoaded() {
        return this.$store.getters[this.isLoaded];
      },
    },
    methods: {
      loadMore: function() {
        this.$emit('clickLoadMore')
      },
      refresh: function() {
        this.$emit('refresh');
      },
      create: function() {
        this.$emit('createNew');
      }
    }
  }
</script>

<style scoped>
  .custom-top-info {
    display: flex;
    align-items: center;
    height: 40px;
  }

  .btn-topbar {
    width: 10%;
    display: flex;
    justify-content: flex-end;
  }

  .no-margin-bottom {
    margin-bottom: 0;
    width: 15%;
  }
</style>